import { getLang } from "locale";

// Date format of each app language (date-fns tokens). It follows the app
// language, not the browser's, so everyone sees the same date the same way;
// browsers also lack some of these locales (lb, az)
const DATE_FORMATS = {
  az: "dd.MM.yyyy",
  de: "dd.MM.yyyy",
  en: "dd/MM/yyyy",
  es: "dd/MM/yyyy",
  fr: "dd/MM/yyyy",
  it: "dd/MM/yyyy",
  lb: "dd.MM.yyyy",
  "nb-NO": "dd.MM.yyyy",
  nl: "dd-MM-yyyy",
  ru: "dd.MM.yyyy",
  tr: "dd.MM.yyyy",
  uk: "dd.MM.yyyy"
};

const DEFAULT_FORMAT = DATE_FORMATS.tr;

// For date-fns and the date pickers ("dd.MM.yyyy"); also outside components
export const dateFormat = () => DATE_FORMATS[getLang()] || DEFAULT_FORMAT;

export function useLocaleFormatPicker() {
  return dateFormat();
}

// For dayjs ("DD.MM.YYYY")
export function useLocaleFormat() {
  return useLocaleFormatPicker().replace("dd", "DD").replace("yyyy", "YYYY");
}
